// extracted by mini-css-extract-plugin
module.exports = {"banner-layout":"e2ff468f85--banner-layout--NmwjM"};